import {simpleAction} from "../../utils";
import * as TYPES from "./types";

/**
 * Request Products
 * @type {function(type: string): {type: string, payload: any}}
 */
export const colorsGetRequest = simpleAction(TYPES.COLORS_GET_REQUEST);

/**
 * Request colors success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const colorsGetSuccess = simpleAction(TYPES.COLORS_GET_SUCCESS);

/**
 * Request colors error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const colorsGetError = simpleAction(TYPES.COLORS_GET_FAIL);
